import { createApiRef } from '@backstage/frontend-plugin-api';
import { Account } from '@internal/backstage-plugin-catalog-devops-common';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const accountApiRef = createApiRef<AccountApi>().with({
  id: 'account-api',
  pluginId: 'catalog-devops',
});

export interface AccountApi {
  getUsers(groupRef?: string): Promise<DefaultApiResponse>;
  createAccountEntity(data: Account): Promise<DefaultApiResponse>;
  editAccountEntity(id: string, data: Account): Promise<DefaultApiResponse>;
  deleteAccountEntity(id: string): Promise<DefaultApiResponse>;
}
